export default "__VITE_ASSET__DkAThYmR__"